export default __webpack_public_path__ + "static/media/dinesh_publications.be8bb776.gif";